import { Alert, Space, Typography } from 'antd';
import { FC } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import { AudienceAccordion } from '../AudienceAccordion';
import { AudienceConfiguration } from '../AudienceConfiguration';

const { Text } = Typography;

export const ConfigurationStep: FC = () => {
  const { control } = useFormContext();

  const { field: subscriberEnabled } = useController({
    control,
    name: 'configuration.subscriber.enabled',
  });

  const { field: freemiumEnabled } = useController({
    control,
    name: 'configuration.freemium.enabled',
  });

  const atLeastOneError =
    !subscriberEnabled.value && !freemiumEnabled.value
      ? 'Pelo menos um público (Assinante ou Freemium) deve estar habilitado'
      : undefined;

  return (
    <Space direction='vertical' size={16} style={{ width: '100%' }}>
      <Text style={{ fontSize: 16, fontWeight: 500 }}>
        Selecione para quem você deseja configurar ofertas
      </Text>

      {atLeastOneError && (
        <Alert type='error' message={atLeastOneError} showIcon />
      )}

      <AudienceAccordion
        title='Assinantes'
        description='Usuários com assinatura ativa'
        enabled={subscriberEnabled.value}
        onToggle={subscriberEnabled.onChange}
      >
        <AudienceConfiguration audienceKey='subscriber' />
      </AudienceAccordion>

      <AudienceAccordion
        title='Freemium'
        description='Usuários sem assinatura (gratuitos e ex-clientes)'
        tooltip={
          <span>
            Usuários sem assinatura ativa, incluindo:
            <br />• Novos cadastros
            <br />• Ex-clientes (cancelados)
            <br />• Leads e usuários B2B
            <br />• Addons (Compra avulsa)
          </span>
        }
        enabled={freemiumEnabled.value}
        onToggle={freemiumEnabled.onChange}
      >
        <AudienceConfiguration audienceKey='freemium' />
      </AudienceAccordion>
    </Space>
  );
};
